import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { portalFetch } from "../../api/http";
import { TagCatalogWorkspace } from "../../contacts/TagCatalogWorkspace";
import { contactBaseTextKeys } from "../../contacts/contactModel";
import { tagR1TextKeys, tagR2TextKeys, tagTextKeys } from "../../contacts/tagTextKeys";
import { portalHref } from "../../shell/routes";
import type { ShellData } from "../../shell/shellModel";

/** Regreso al padre (MobileBack.razor): visible también en escritorio cuando la pantalla lo pide. */
export function MobileBack({
  href,
  label,
  alwaysVisible = false,
  iconOnly = false,
}: {
  href: string;
  label: string;
  alwaysVisible?: boolean;
  iconOnly?: boolean;
}) {
  return (
    <a
      className={`mobile-back ${alwaysVisible ? "page-back" : ""} ${iconOnly ? "page-back-icon" : ""}`}
      href={portalHref(href)}
      aria-label={label}
    >
      <span aria-hidden="true">‹</span>
      {!iconOnly ? label : null}
    </a>
  );
}

/**
 * Etiquetas (/portal/chat/configuracion/etiquetas): como Bandejas, ← a Configuración en la fila del título y sin
 * pestañas. Roles y permisos es otra pantalla del menú (/portal/chat/configuracion/roles).
 */
export function TagsPage({ shell, locale }: { shell: ShellData; locale: string }) {
  const [user, tenant] = shell.reportScope.split(":").map(Number) as [number, number];
  const texts = useQuery({
    queryKey: ["texts", locale, "tags"],
    queryFn: async () => {
      const all = await portalFetch<Record<string, string>>(`/api/portal/texts/${locale}?prefixes=E1_,E3_,C1_`);
      // Solo las claves de la pantalla; una que falte se ve marcada.
      return Object.fromEntries(
        [...tagTextKeys, ...tagR1TextKeys, ...tagR2TextKeys, ...contactBaseTextKeys].filter((key) => key in all).map((key) => [key, all[key]!]),
      );
    },
  });
  const labels = texts.data;
  useEffect(() => {
    if (labels) document.title = `${labels["E1_TITLE"] ?? ""} · Bheli`;
  }, [labels]);
  if (!labels) return null;
  return <TagCatalogWorkspace labels={labels} locale={locale} tenant={tenant} user={user} />;
}
